import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
import { request } from '@/api/service';
import chart from './chart';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  // { this.p('add') ? <d2-bar-cell>{ this.vNodeButtonCreate }</d2-bar-cell> : null }
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.vNodeButtonEchart, this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])])]), "\u77ED\u4FE1\u4E2D\u6587\u6309\u716765\u4E2A\u5B57\u7B26\u4E00\u6761\uFF0C\u82F1\u658767\u4E2A\u5B57\u7B26\u4E00\u6761", h("span", {
      "style": "color:blue"
    }, ["The short message is 65 characters in Chinese and 67 characters in English"]), h(chart, {
      "directives": [{
        name: "show",
        value: this.chart_show
      }],
      "model": {
        value: _this.chart_show,
        callback: function callback($$v) {
          _this.chart_show = $$v;
        }
      }
    }), this.p('query') ? this.vNodeSearchForm2 : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      chart_show: false,
      api: {
        index: 'SMS_RECHARGE_ALL',
        delete: 'SMS_RECHARGE_DELETE'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: '',
        remove: ''
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '80px'
      }, {
        prop: 'market_id',
        label: this.$t('market_id'),
        minWidth: '120px'
      }, // { prop: 'app_id', label: 'app_id', width: '330px' },
      // { prop: 'key', label: 'key', width: '330px' },
      {
        prop: 'order_no',
        label: this.$t('order_no'),
        minWidth: '330px'
      }, {
        prop: 'recharge_count',
        label: this.$t('charge count'),
        minWidth: '330px'
      }, // { prop: 'sign', label: 'sign', width: '330px' },
      {
        prop: 'c_time',
        label: this.$t('c_time'),
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.c_time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'u_time',
        label: this.$t('u_time'),
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.u_time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'pay_time',
        label: this.$t('pay_time'),
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.pay_time, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      return function (_ref) {
        var row = _ref.row;
        return [// ...this.p('edit', [{ icon: 'el-icon-edit-outline', action: () => this.edit(row.id) }], []),
          // ...this.p('remove', [{ icon: 'el-icon-delete', type: 'danger', confirm: `确定删除吗`, action: () => this.delete(row.id) }], [])
        ];
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this2 = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        label: this.$t('market_id'),
        default: utils.cookies.get('market_id'),
        show: false,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "model": {
              value: _this2.search.form.model.market_id,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "market_id", $$v);
              }
            }
          });
        } // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:140px;" custom clearable/>

      }, {
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "开始时间"
            },
            "style": "width:130px;",
            "model": {
              value: _this2.search.form.model.start_time,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "结束时间"
            },
            "style": "width:130px;",
            "model": {
              value: _this2.search.form.model.end_time,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    },
    settinginfoLabel: function settinginfoLabel() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'sms_rest_count',
        label: this.$t('sms_rest_count'),
        default: '',
        render: function render() {
          return h("d2-span", {
            "style": "width:100px;",
            "model": {
              value: _this3.search.form.model.sms_rest_count,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "sms_rest_count", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    goSmsRecharge: function goSmsRecharge() {
      this.closeBy(function (page) {
        return page.name === 'sms-recharge';
      });
      this.$router.push({
        name: 'sms-recharge',
        query: {
          mobile: utils.cookies.get('phone')
        }
      });
    },
    loadDict: function loadDict() {
      var _this4 = this;

      request({
        method: 'post',
        url: '/api/sms-market/index',
        data: {}
      }).then(function (res) {
        console.log(res.list[0].rest);
        _this4.search.form.model.sms_rest_count = res.list[0].rest;
      });
    }
  })
};